import NextLink from 'next/link';

import { followUser, selectCurrentUser } from 'features/auth/slice';
import { useDispatch, useSelector } from 'react-redux';

import { Heading, recordsContain } from '@frontendmentorio/design-system-v2';

import AuthButton from 'features/shared/AuthButton';
import Avatar from 'features/shared/Avatar';
import Badges from './Badges';
import SocialLinks from './SocialLinks';

export default function Hero({ isCurrentUser, user }) {
  const dispatch = useDispatch();

  const currentUser = useSelector(selectCurrentUser);
  const isFollowedByUser = recordsContain(currentUser?.following, user);

  return (
    <div className="bg-white px-5 py-7">
      <div className="container-xl flex flex-col gap-6 items-center tablet:flex-row tablet:items-start tablet:gap-5 tablet:*:w-1/2">
        <div className="flex flex-col gap-5 w-full tablet:flex-row tablet:min-w-[30rem]">
          <div className="flex flex-col gap-4 items-center">
            <div className="flex flex-col items-center">
              <Avatar size="xl" user={user} withModal />

              {isCurrentUser && (
                <NextLink
                  className="bg-cyan-500 font-bold mt-[-1.5rem] px-2 py-1 rounded text-white text-sm uppercase z-10"
                  href="/settings"
                >
                  Edit profile
                </NextLink>
              )}
            </div>

            {!isCurrentUser && (
              <AuthButton
                isGhost={isFollowedByUser}
                level="secondary"
                onClick={() => dispatch(followUser({ id: user.id }))}
              >
                {isFollowedByUser ? 'Unfollow' : 'Follow'}
              </AuthButton>
            )}
          </div>

          <div className="flex flex-col gap-2 items-center min-w-0 tablet:items-stretch">
            <Heading className="truncate max-w-full" level="4" tagName="h1">
              {user.displayName}
            </Heading>

            <span className="text-neutral-500 truncate">@{user.username}</span>

            {user.location && (
              <span className="font-bold text-blue-500">{user.location}</span>
            )}

            <span>
              <span className="font-bold font-secondary text-2xl">
                {(user.mentorScore.total ?? user.mentorScore).toLocaleString()}{' '}
              </span>

              <span className="font-secondary font-semibold text-lg text-neutral-500">
                points
              </span>
            </span>

            {user.links && <SocialLinks user={user} />}
          </div>
        </div>

        <div className="flex flex-col gap-4 text-center tablet:text-start">
          <p className={user.bio ? '' : 'italic text-neutral-500'}>
            {user.bio ||
              'I’m a mysterious individual who has yet to fill out my bio. One thing’s for certain: I love writing front-end code!'}
          </p>

          {user.learning && (
            <>
              <span className="font-bold text-blue-500">
                I’m currently learning...
              </span>

              <p>{user.learning}</p>
            </>
          )}

          {user.achievements.length > 0 && <Badges user={user} />}
        </div>
      </div>
    </div>
  );
}
